import script from "./WksOpenInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./WksOpenInput.vue?vue&type=script&setup=true&lang=ts"

import "./WksOpenInput.vue?vue&type=style&index=0&id=42a4ae57&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42a4ae57"]])

export default __exports__